"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpoints = exports.useBreakpoint = void 0;
var useWindowSize_1 = require("./useWindowSize");
function useBreakpoint(breakpoint) {
    var width = (0, useWindowSize_1.useWindowSize)().width;
    return width < breakpoint;
}
exports.useBreakpoint = useBreakpoint;
function useBreakpoints(breakpoints) {
    var width = (0, useWindowSize_1.useWindowSize)().width;
    return breakpoints.map(function (breakpoint) { return width < breakpoint; });
}
exports.useBreakpoints = useBreakpoints;
//# sourceMappingURL=useBreakpoint.js.map